import { Injectable } from '@angular/core';
import {LogRequestDto} from '../../shared/interfaces/log-request-dto';
import {GoogleService} from '../../api-services/google.service';
import {environment} from '../../../environments/environment';
import {SessionService} from './session.service';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {
  // service生成時に一度だけ乱数をセット。
  private readonly sessionId = this.genSessionId();
  private readonly projectId = environment.firebaseConfig.projectId;

  constructor(
    private googleService: GoogleService,
    private sessionService: SessionService,
  ) { }

  /**
   * Goサーバへログ保存リクエスト送信（Info）
   *
   * @param pathName
   * @param innerHtml
   */
  info(pathName: string = location.href, logType: string, dto: any = {}) {
    const genzaiJigyoushoId = this.sessionService.session?.personalSetting?.customerId ?? '';
    const userMail = this.sessionService.session?.personalSetting?.mail ?? '';
    return this.googleService.request<LogRequestDto>(
      '/api/log/client',
      {
        projectId: this.projectId,
        appName: 'TOSAKA',
        logType,
        url: pathName ?? '',
        user: userMail, // ログインユーザーのメールアドレス
        logName: "projects/"+ this.projectId +"/logs/" + environment.origin,
        level: 'info',
        jigyoushoId: genzaiJigyoushoId,
        sessionId: this.sessionId, // セッションID
        innerHtml: '',
        message: '',
        stack: '',
        payload: dto,
      }
    );
  }

  /**
   * Goサーバへログ保存リクエスト送信（Error）
   *
   * @param message
   * @param stack
   * @param pathName
   */
  error(message: string | null, stack: string | undefined | null, pathName: string | null, dto: any = {}) {
    const genzaiJigyoushoId = this.sessionService.session?.personalSetting?.customerId ?? '';
    const userMail = this.sessionService.session?.personalSetting?.mail ?? '';
    return this.googleService.request<LogRequestDto>(
      '/api/log/client',
      {
        projectId: this.projectId,
        appName: 'TOSAKA',
        LogType: 'error',
        url: pathName ?? '',
        user: userMail, // ログインユーザーのメールアドレス
        logName: "projects/"+ this.projectId +"/logs/" + environment.origin,
        level: 'error',
        jigyoushoId: genzaiJigyoushoId,
        sessionId: this.sessionId, // セッションID
        innerHtml: '',
        message: message?? '',
        stack: stack ?? '',
        payload: dto,
      }
    );
  }

  /**
   * 乱数を生成する。
   */
  genSessionId() {
    const uint32Array = new Uint32Array(1);
    self.crypto.getRandomValues(uint32Array);
    return uint32Array[0].toString();
  }
}
